/* Estimated calendar dates for the India storefront; does not alter shipping or order data. */
if (!customElements.get('bc-delivery-dates')) {
 customElements.define('bc-delivery-dates', class extends HTMLElement {
  connectedCallback() {
   this.refresh();
   this.timer = setInterval(() => this.refresh(), 60000);
   this.onVisible = () => { if (!document.hidden) this.refresh(); };
   document.addEventListener('visibilitychange', this.onVisible);
  }
  refresh() {
   const parts = new Intl.DateTimeFormat('en-CA', {timeZone:'Asia/Kolkata',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
   const date = Object.fromEntries(parts.filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
   const format = new Intl.DateTimeFormat(document.documentElement.lang || 'en-IN', {timeZone:'UTC',day:'2-digit',month:'short'});
   this.querySelectorAll('time[data-delivery-offset]').forEach(time => {
    const target = new Date(Date.UTC(date.year,date.month-1,date.day+Number(time.dataset.deliveryOffset),12));
    const iso = target.toISOString().slice(0,10);
    if (time.dateTime !== iso || !time.dataset.dateUpdated) {
     time.dateTime = iso; time.textContent = format.format(target); time.dataset.dateUpdated = 'true';
    }
   });
  }
  disconnectedCallback() {
   clearInterval(this.timer); document.removeEventListener('visibilitychange', this.onVisible);
  }
 });
}
